import { Facebook } from "@mui/icons-material";
import { Box, Button, Grid2, Stack, Typography } from "@mui/material";
import { GoogleLogin } from "@react-oauth/google";
import React from "react";
import TextTransition, { presets } from 'react-text-transition';
import { useAppStore } from "../app/store";
import authService from "./auth.service";

export default function LoginView() {
	const { setUser } = useAppStore();
	const [textIndex, setTextIndex] = React.useState(0);
	const texts = ['great!', 'fun!', 'fulfilling!', 'meaningful!', 'fabulous!'];

	const year = new Date().getFullYear();


	React.useEffect(() => {
		const intervalId = setInterval(
			() => setTextIndex((index) => index + 1),
			3000, // every 3 seconds
		);
		return () => clearTimeout(intervalId);
	}, []);

	const onLogin = async (credentialResponse) => {
		const result = await authService.login('google', credentialResponse);
		setUser(result?.data?.data);
		if( window.location.pathname.indexOf('login') >= 0 ){
			window.location.pathname = '/';
		}
	}

	return (
		<Grid2 container sx={{ overflow: 'hidden' }}>
			<Grid2 size={{ xs: 12, sm: 6, md: 5, lg: 4, xl: 3 }}>
				<Stack direction="column" justifyContent="space-between" alignItems="center" sx={{ p: 4, height: '100vh', flex: 1 }}>
					<Typography variant="h1" align="left" sx={{ width: '100%' }}>Prospect Academy</Typography>
					<Stack direction="column" sx={{ pb: 24 }}>
						<Typography variant="h5">Sign In</Typography>
						<Typography sx={{ pb: 2 }}>Use one of the services for the most secure experience</Typography>
						<GoogleLogin onSuccess={onLogin} text="sign me in" useOneTap={false} />
						<Button variant="contained" disabled><Facebook /> Coming Soon</Button>
					</Stack>
					<Typography variant="subtitle2">&copy; {year} - Prospect Academy Learning</Typography>
				</Stack>
			</Grid2>
			<Grid2 size={{ xs: 12, sm: 6, md: 7, lg: 8, xl: 9 }} sx={{}}>
				<Box sx={{ position: 'relative', overflow: 'hidden', height: '100vh' }}>
					<Box sx={{ position:'absolute', width: '100%', height: '100%', top:0,left: 0,backgroundImage: 'url(/bg1.png)', backgroundSize: 'cover', backgroundPosition: 'center', opacity: 0.25 }} />
					<Box sx={{px:24, py: 16}}>
						<Typography variant="h2">
							Let's make today <TextTransition inline={true} springConfig={presets.gentle}>{texts[textIndex % texts.length]}</TextTransition>
						</Typography>
					</Box>
				</Box>
			</Grid2>
		</Grid2>

	);
};